<template>
  <div class="login">
    <md-field>
      <p style="font-size: 0.3rem;text-align: left">
        请在下面输入您注册时所使用的邮箱地址。
        系统将发送一封可重置密码的链接到您的邮箱，您可以点击该链接重设您的密码。
      </p>

      <p style="font-size: 0.3rem;text-align: left;margin-top: 0.5rem">
        这个链接很重要，请不要告诉他人。
      </p>
      <md-input-item
        ref="input0"
        v-model="userName"
        placeholder="請輸入郵箱"
        @change="checkBankCard"
      >
        <img
          src="@/assets/image/icon_email.png"
          alt=""
          slot="left"
          class="logo"
        />
        <p v-if="isError" class="error" slot="error">
          請輸入正確的郵箱地址
        </p></md-input-item
      >
    </md-field>
    <div>
      <md-button
        :type="!isError && userName ? 'warning' : 'disabled'"
        round
        style="width: 90%;margin-left: 5%;height: 0.9rem;"
        @click="login"
      >
        <md-activity-indicator
          v-if="loading"
          class="md-activity-indicator-css"
          type="carousel"
          :size="15"
          color="#fff"
          text-color="#fff"
        ></md-activity-indicator>
        <span v-else>提交</span>
      </md-button>
    </div>
    <md-landscape v-model="showFullScreen" full-screen>
      <div class="fullcontainer">
        <md-icon name="success" size="lg" color="#097ef7"></md-icon>
        <p>重制密碼的郵件已發送到</p>
        <span>{{ userName }}</span>
        <div class="div">
          <p class="p">
            重置鏈接有效期為10分鐘，請在有效期內打開郵
            件，根據提示操作重設密碼。
          </p>
          <p class="p">如果您沒到郵件，請檢查您的“垃圾收件箱。</p>
          <md-button type="primary" style="margin-top: 0.5rem" @click="wanch"
            >知道了</md-button
          >
        </div>
      </div>
    </md-landscape>
  </div>
</template>

<script>
import {
  ActivityIndicator,
  Button,
  Landscape,
  Field,
  FieldItem,
  Icon,
  InputItem
} from "mand-mobile";
import md5 from "js-md5";

export default {
  name: "ForgetModal",
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Landscape.name]: Landscape,
    [ActivityIndicator.name]: ActivityIndicator
  },
  data() {
    return {
      showpass: true,
      isError: false,
      showFullScreen: false,
      userName: "",
      loading: false
    };
  },
  props: {
    // 店铺参数
    shopkey: {}
  },
  methods: {
    checkBankpassWord() {
      if (!this.passWord) {
        this.isErrorpas = true;
      } else {
        this.isErrorpas = false;
      }
    },
    checkBankCard() {
      var reg = new RegExp(
        "^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*\$"
      );
      if (!reg.test(this.userName)) {
        this.isError = true;
      } else {
        this.isError = false;
      }
    },
    wanch() {
      this.showFullScreen = false;
      this.$parent.code = true;
    },
    // 忘记密码
    login() {
      this.loading = true;
      const par = {
        account: this.userName.trim(),
        appCode: this.shopkey.appCode
      };
      this.http
        .APIASK(this.ports.sendPasswordMail, "post", par)
        .then(res => {
          this.showFullScreen = true;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less">
.logo {
  width: 0.55rem;
  height: auto;
}

.error {
  text-align: left;
}
.fullcontainer {
  margin-top: 1rem;
  .md-icon.icon-font.lg {
    font-size: 2rem;
  }
  p {
    margin: 0.2rem 0;
  }
  .div {
    width: 90%;
    margin-left: 5%;
    margin-top: 0.5rem;
    .p {
      color: #e51c23;
      text-align: left;
    }
  }
}
</style>
